import React from "react";
import { Helmet } from "react-helmet";
import queryString from "query-string";
import { useQueryClient } from "react-query";

import SettingsContainer from "@ats/src/components/shared/SettingsContainer";
import LoadingIndicator from "@ats/src/components/shared/LoadingIndicator";
import BetaTag from "@ats/src/components/shared/BetaTag";

import { useOrganizationAiCreditPurchasePrices } from "@shared/queryHooks/useOrganizationAiCreditPurchase";

import AiCreditSubscription from "./accountPlatoAi/AiCreditSubscription";

function OrganizationAiBilling(props: any) {
  const queryClient = useQueryClient();

  React.useEffect(() => {
    const { ai_credit_subscribe_success, ai_credit_top_up_success } = queryString.parse(props.location.search);

    if (ai_credit_subscribe_success || ai_credit_top_up_success) {
      queryClient.invalidateQueries(["organizationAiCreditPurchase"]);
      queryClient.invalidateQueries(["organizationAiCreditBalance"]);
      queryClient.invalidateQueries(["aiCreditCustomerSubscription"]);
    }
  }, []);

  /* Billing Prices
  --===================================================-- */
  const { data: pricesData, isFetching: isFetchingPrices } = useOrganizationAiCreditPurchasePrices({
    refetchOnWindowFocus: false,
  });

  if (isFetchingPrices) {
    return <LoadingIndicator label="Loading..." />;
  }

  return (
    <>
      <Helmet title="Plato AI billing" />
      <SettingsContainer
        title={<>Plato AI billing <BetaTag variant="filledDarkOnly" /></>}
        description="Manage your organization's Plato AI credits. Subscribe for credits that refresh each billing period, or buy a one-time top-up pack. Every successful Plato review spends one credit."
        fullWidthForm={true}
      >
        <AiCreditSubscription pricesData={pricesData} />
      </SettingsContainer>
    </>
  );
}

export default OrganizationAiBilling;
